<template>
  <div class="car-detail-container">
    <div class="back">
      <span @click="$router.go(-1)">
        <i class="iconfont icon-back"></i>返回
      </span>
    </div>
    <div class="content">
      <div class="tools">
        <div class="title">车辆信息</div>
        <div>
          <el-button
            type="primary"
            class="btn-edit"
            @click="editClick"
            v-hasPermi="['车辆管理', '编辑']"
            >编辑</el-button
          >
          <el-button
            v-if="edit && form.tbox_num"
            type="success"
            class="btn-edit"
            @click="untie()"
            >解绑</el-button
          >
          <el-button
            v-if="edit"
            type="success"
            class="btn-edit"
            @click="submitForm('form')"
            >保存</el-button
          >
          <el-button
            v-if="edit"
            type="primary"
            class="btn-edit"
            @click="cancelClick"
            >取消编辑</el-button
          >
        </div>
      </div>
      <div class="box">
        <div class="avatar" style="width: 450px">
          <div class="img">
            <!-- <el-upload
                class="avatar-uploader"
                :action="process.env.VUE_APP_BASE_API+ '/data/upload'"
                :show-file-list="false"
                :disabled="!edit"
                :on-success="handleAvatarSuccess"
                :headers="{'Authorization':'bearer' + token  }"
                >
                <img v-if="form.photo" :src="form.photo" class="avatar">
                 <img v-else src="@/assets/images/car.jpg" alt=""> 
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>-->
            <img v-if="form.type_img" :src="form.type_img" class="avatar" />
            <!-- <img v-else src="@/assets/images/car.jpg" alt=""> -->
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
        </div>
        <div class="form">
          <el-form ref="form" :model="form" :rules="rules" label-width="160px">
            <!--***********4s店 或 自定义****start********************-->
            <!-- <template
              v-if="
                $store.state.home.RoleId == this.user_role_four ||
                $store.state.home.RoleId == this.user_role_defind
              "
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车架号" prop="frame_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.frame_num"
                        disabled
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.frame_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生产日期">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.product_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.product_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆品牌" prop="brand">
                    <el-select
                      v-model="form.brand"
                      placeholder="请选择"
                      style="width: 100%"
                      disabled
                    >
                      <el-option
                        v-for="item in options.brand"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车型" prop="model">
                    <el-select
                      v-model="form.model"
                      placeholder="请选择"
                      style="width: 100%"
                      disabled
                    >
                      <el-option
                        v-for="item in options.carModelOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆型号" prop="type">
                    <el-select
                      v-model="form.type"
                      placeholder="请选择"
                      style="width: 100%"
                      disabled
                    >
                      <el-option
                        v-for="item in options.carTypeOptions"
                        :key="item.id"
                        :label="item.type"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="维护时间" prop="maintenance_time">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.maintenance_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.maintenance_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="底盘型号">
                    <template v-if="edit">
                      <el-input
                        v-model="form.chassis"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.chassis }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头信息">
                    <template v-if="edit">
                      <el-input
                        v-model="form.camera"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.camera }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车牌号" prop="license_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.license_num"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.license_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车主身份证">
                    <template v-if="edit">
                      <el-input
                        v-model="form.master_idcard"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.master_idcard }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车主姓名">
                    <template v-if="edit">
                      <el-input
                        v-model="form.car_master"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.car_master }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车主联系方式">
                    <template v-if="edit">
                      <el-input
                        v-model="form.master_contact"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.master_contact }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="所属公司" prop="belong_company">
                    <template
                      v-if="
                        edit &&
                        $store.state.home.RoleId != this.user_role_four &&
                        $store.state.home.RoleId != this.user_role_defind &&
                        !editAdmin
                      "
                    >
                      <el-select
                        v-model="form.belong_company"
                        @change="selectChange"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.belongCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.belong_company"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.belongCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <template v-if="edit">
                    <el-form-item
                      label="租赁或个人"
                      placeholder="请选择租赁或个人"
                      prop="rent_company"
                    >
                      <el-select
                        v-model="form.rent_company"
                        clearable
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.rentCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                  <template v-else>
                    <el-form-item
                      label="租赁或个人"
                      placeholder="请选择租赁或个人"
                      prop="rent_company"
                    >
                      <el-select
                        v-model="form.rent_company"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.rentCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="配置">
                    <template v-if="edit">
                      <el-select
                        v-model="form.configuration"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.configOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.configuration"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.configOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电子说明书">
                    <a :href="form.instruction_url" target="_blank">{{
                      form.instruction_url ? "说明书" : ""
                    }}</a>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="服务截至日期" prop="maintenance_time">
                    <template>
                      <span class="value">{{ form.maturity_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </template> -->
            <!--***********4s店 或 自定义****end********************-->
            <!--***********租赁公司****start********************-->
            <!-- <template
              v-else-if="$store.state.home.RoleId == this.user_role_rent"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车架号" prop="frame_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.frame_num"
                        disabled
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.frame_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生产日期">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.product_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.product_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车工号" prop="work_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.work_num"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.work_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="维护时间" prop="maintenance_time">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.maintenance_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.maintenance_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆品牌" prop="brand">
                    <el-select
                      v-model="form.brand"
                      placeholder="请选择"
                      style="width: 100%"
                      disabled
                    >
                      <el-option
                        v-for="item in options.brand"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="底盘型号">
                    <template v-if="edit">
                      <el-input
                        v-model="form.chassis"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.chassis }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头信息">
                    <template v-if="edit">
                      <el-input
                        v-model="form.camera"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.camera }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车牌号" prop="license_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.license_num"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.license_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车主身份证">
                    <template v-if="edit">
                      <el-input
                        v-model="form.master_idcard"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.master_idcard }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车主姓名">
                    <template v-if="edit">
                      <el-input
                        v-model="form.car_master"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.car_master }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车主联系方式">
                    <template v-if="edit">
                      <el-input
                        v-model="form.master_contact"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.master_contact }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="所属公司" prop="belong_company">
                    <template
                      v-if="
                        edit &&
                        $store.state.home.RoleId != this.user_role_four &&
                        $store.state.home.RoleId != this.user_role_defind &&
                        !editAdmin
                      "
                    >
                      <el-select
                        v-model="form.belong_company"
                        @change="selectChange"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.belongCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.belong_company"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.belongCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <template v-if="edit">
                    <el-form-item
                      label="租赁或个人"
                      placeholder="请选择租赁或个人"
                      prop="rent_company"
                    >
                      <el-select
                        v-model="form.rent_company"
                        clearable
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.rentCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                  <template v-else>
                    <el-form-item
                      label="租赁或个人"
                      placeholder="请选择租赁或个人"
                      prop="rent_company"
                    >
                      <el-select
                        v-model="form.rent_company"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.rentCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="服务截至日期" prop="maintenance_time">
                    <template>
                      <span class="value">{{ form.maturity_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </template> -->
            <!--***********租赁公司****end********************-->
            <!--***********生产用户****start********************-->
            <template>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车架号" prop="frame_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.frame_num"
                        disabled
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.frame_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生产日期">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.product_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.product_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车工号" prop="work_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.work_num"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.work_num }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="维护时间" prop="maintenance_time">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.maintenance_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.maintenance_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆品牌" prop="brand">
                    <template v-if="edit">
                      <el-select
                        v-model="form.brand"
                        @change="brandChange"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.brand"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.brand"
                        placeholder="请选择"
                        style="width: 100%"
                        disabled="disabled"
                      >
                        <el-option
                          v-for="item in options.brand"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车型" prop="model">
                    <template v-if="edit">
                      <el-select
                        v-model="form.model"
                        @change="modelChange"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.carModelOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.model"
                        placeholder="请选择"
                        style="width: 100%"
                        disabled="disabled"
                      >
                        <el-option
                          v-for="item in options.carModelOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆型号" prop="type">
                    <template v-if="edit">
                      <el-select
                        v-model="form.type"
                        @change="typeChange"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.carTypeOptions"
                          :key="item.id"
                          :label="item.type"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.type"
                        placeholder="请选择"
                        style="width: 100%"
                        disabled="disabled"
                      >
                        <el-option
                          v-for="item in options.carTypeOptions"
                          :key="item.id"
                          :label="item.type"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="底盘型号">
                    <template v-if="edit">
                      <el-input
                        v-model="form.chassis"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.chassis }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <!-- <el-form-item label="车牌号" prop="license_num">
                    <template v-if="edit">
                      <el-input v-model="form.license_num" disabled placeholder="请输入"></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.license_num }}</span>
                    </template>
                  </el-form-item> -->
                  <el-form-item label="TBox编号" prop="tbox_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.tbox_num"
                        @focus.stop="dialogVisible = true"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span
                        class="value"
                        style="width: 300px"
                        v-show="!tboxSelectVisible"
                        >{{ form.tbox_num }}</span
                      >
                      <el-select
                        v-model="form.tbox_num"
                        v-show="tboxSelectVisible"
                        placeholder="请选择"
                        filterable
                        @change="editTbox()"
                        style="width: 300px"
                      >
                        <el-option
                          v-for="item in tboxData"
                          :key="item.tbox_num"
                          :label="item.tbox_num"
                          :value="item.tbox_num"
                        >
                        </el-option>
                      </el-select>
                      <el-button
                        type="primary"
                        v-show="!tboxSelectVisible"
                        @click="openEditBtn()"
                        >更换</el-button
                      >
                      <el-button
                        type="primary"
                        v-show="tboxSelectVisible"
                        @click="closeEditBtn()"
                        >取消</el-button
                      >
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像头信息">
                    <template v-if="edit">
                      <el-input
                        v-model="form.camera"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.camera }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="display: flex; flex-wrap: wrap;">
                <el-col
                  :span="12"
                  v-for="(item, index) in serviceList"
                  :key="index"
                >
                  <el-form-item :label="item.name">
                    <template v-if="edit">
                      <el-input
                        clearable
                        @clear="clearHardware(index)"
                        :value="item.code"
                        @focus.stop="showHardwareDialog(item.id, item.code)"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ item.code }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车主姓名">
                    <template v-if="edit">
                      <el-input
                        v-model="form.car_master"
                        disabled
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.car_master }}</span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车主联系方式">
                    <template v-if="edit">
                      <el-input
                        v-model="form.master_contact"
                        disabled
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.master_contact }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <!-- <el-form-item label="车牌号" prop="license_num">
                    <template v-if="edit">
                      <el-input
                        v-model="form.license_num"
                        disabled
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.license_num }}</span>
                    </template>
                  </el-form-item> -->
                  <el-form-item label="车主身份证">
                    <template v-if="edit">
                      <el-input disabled placeholder="请输入"></el-input>
                    </template>
                    <template v-else>
                      <span class="value"></span>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="配置">
                    <template v-if="edit">
                      <el-select
                        v-model="form.configuration"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.configOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.configuration"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.configOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="所属公司" prop="belong_company">
                    <template v-if="edit">
                      <el-select
                        v-model="form.belong_company"
                        @change="selectChange"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.belongCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="form.belong_company"
                        disabled
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in options.belongCompDataOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电子说明书">
                    <!-- <template v-if="edit">
                      <el-input type="textarea" v-model="form.e_instruction" placeholder="请输入"></el-input>
                    </template> -->
                    <template>
                      <a :href="form.instruction_url" target="_blank">{{
                        form.instruction_url ? '说明书' : ''
                      }}</a>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="服务截至日期" prop="maintenance_time">
                    <template v-if="edit">
                      <el-date-picker
                        v-model="form.maturity_time"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="选择日期时间"
                      ></el-date-picker>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.maturity_time }}</span>
                    </template>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="ic卡">
                    <template v-if="edit">
                      <el-input
                        v-model="form.iccid"
                        @focus.stop="dialogVisible = true"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.iccid }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="归属部门">
                    <template v-if="edit">
                      <el-select
                        style="width: 100%"
                        v-model="form.belong_department"
                        placeholder="请选择"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in departList"
                          :key="index"
                          :label="item.department"
                          :value="item.department"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template v-else>
                      <span class="value">{{ form.belong_department }}</span>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!--***********生产用户****end********************-->
          </el-form>
        </div>
      </div>
      <div class="detail-info">
        <el-tabs v-model="tabs.avtive" @tab-click="handleClick">
          <el-tab-pane label="历史报警数据" name="历史报警数据">
            <div class="pane-table">
              <el-table
                stripe
                :data="table.lsbjsj.list"
                :header-cell-style="{ background: '#eaeef6' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="alarm_num"
                  label="报警编号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="alarm_time"
                  label="报警时间"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="alarm_type"
                  label="报警类型"
                  align="center"
                ></el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="{ row }">
                    <span v-if="row.status == 0" style="color: #f00"
                      >未处理</span
                    >
                    <span v-if="row.status == 1">已处理</span>
                    <span v-if="row.status == 2" style="color: #f00"
                      >待处理</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="alarm"
                  label="报警内容"
                  align="center"
                ></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <div class="edit" v-if="scope.row.status === 2">
                      <el-button
                        type="danger"
                        size="mini"
                        @click="readClickLsbjsj(scope.row.id, 0)"
                        >忽略</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="readClickLsbjsj(scope.row.id, 1)"
                        >已确认</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="table.lsbjsj.currentPage"
                  :page-size="table.lsbjsj.size"
                  :total="table.lsbjsj.total"
                  @current-change="currentChangeLsbjsj"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="租赁信息" name="租赁信息">
            <div class="pane-table">
              <el-table
                stripe
                :data="table.zlxx.list"
                :header-cell-style="{ background: '#eaeef6' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="company"
                  label="租赁公司"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="card"
                  label="身份证号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="driver"
                  label="驾驶员信息"
                  align="center"
                  width="120"
                ></el-table-column>
                <el-table-column label="租车时间" align="center">
                  <template slot-scope="scope"
                    >{{ scope.row.start_time }} 至
                    {{ scope.row.end_time }}</template
                  >
                </el-table-column>
                <el-table-column
                  prop="current_mile"
                  label="租车时里程"
                  align="center"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="over_mile"
                  label="已行驶里程"
                  align="center"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="present_mile"
                  label="当前里程数"
                  align="center"
                  width="150"
                >
                  <template slot-scope="res">{{
                    res.row.over_mile && res.row.current_mile
                      ? parseFloat(res.row.over_mile) -
                        parseFloat(res.row.current_mile)
                      : ''
                  }}</template>
                </el-table-column>
                <!-- <el-table-column
                  label="操作"
                  width="170"
                  align="center">
                  <template slot-scope="scope">
                    <div class="edit">
                      <span class="btn read" @click="readClickZlxx(scope.row.id)">查看</span>
                    </div>
                  </template>
                </el-table-column>-->
              </el-table>
              <div class="pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="table.zlxx.currentPage"
                  :page-size="table.zlxx.size"
                  :total="table.zlxx.total"
                  @current-change="currentChangeZlxx"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="车门信息" name="车门信息">
            <div class="pane-table">
              <el-table
                stripe
                :data="table.cmxx.list"
                :header-cell-style="{ background: '#eaeef6' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column prop="location" label="车门" align="center">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.location === 1"
                      src="@/assets/images/zs.png"
                    />
                    <img
                      v-else-if="scope.row.location === 2"
                      src="@/assets/images/zx.png"
                    />
                    <img
                      v-else-if="scope.row.location === 3"
                      src="@/assets/images/ys.png"
                    />
                    <img
                      v-else-if="scope.row.location === 4"
                      src="@/assets/images/yx.png"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="120"
                >
                  <template slot-scope="scope">{{
                    scope.status ? '错误' : '正常'
                  }}</template>
                </el-table-column>
                <el-table-column prop="card" label="开关" align="center">
                  <template slot="header">
                    <span>开关</span>
                    <span class="btn reads">全部开启</span>
                  </template>
                  <template>
                    <el-switch v-model="id" />
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  label="操作"
                  width="170"
                  align="center">
                  <template slot-scope="scope">
                    <div class="edit">
                      <span class="btn read" @click="readClickZlxx(scope.row.id)">查看</span>
                    </div>
                  </template>
                </el-table-column>-->
              </el-table>
              <div class="pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="table.cmxx.currentPage"
                  :page-size="table.cmxx.size"
                  :total="table.cmxx.total"
                  @current-change="currentChangeZlxx"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="车辆状态记录" name="车辆状态记录">
            <div class="pane-table">
              <el-table
                stripe
                :data="onOffLineRecord"
                :header-cell-style="{ background: '#eaeef6' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column prop="sn" label="Box序列号" align="center">
                </el-table-column>
                <el-table-column
                  prop="onOffLine"
                  label="在线/离线"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.onOffLine == 1" style="color: #40ff72"
                      >在线</span
                    >
                    <span v-else>离线</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="设置时间"
                  align="center"
                >
                  <template slot-scope="scope">{{
                    scope.row.createTime | dateYMDHMSFormat
                  }}</template>
                </el-table-column>
              </el-table>
              <div class="pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="recordParam.pageNo"
                  :page-size="recordParam.pageSize"
                  :total="recordCount"
                  @current-change="initCarOnOffLineData"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="车辆归属权变更记录" name="车辆归属权变更记录">
            <div class="pane-table">
              <el-table
                stripe
                :data="transferData"
                :header-cell-style="{ background: '#eaeef6' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column prop="frame_num" label="车架号" align="center">
                </el-table-column>
                <el-table-column
                  prop="out_depart"
                  label="转出单位"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="into_depart"
                  label="转入单位"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="time" label="转移时间" align="center">
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center">
                </el-table-column>
              </el-table>
              <!-- <div class="pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="table.cmxx.currentPage"
                  :page-size="table.cmxx.size"
                  :total="table.cmxx.total"
                  @current-change="currentChangeZlxx"
                ></el-pagination>
              </div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务订购" name="服务订购">
            <div class="pane-table">
              <el-table
                stripe
                :data="orderHardwareList"
                :header-cell-style="{ background: '#eaeef6' }"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                ></el-table-column>

                <el-table-column
                  prop="serviceTypeName"
                  label="服务"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="orderExpireTime"
                  label="服务有效时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                  <template slot-scope="scope">
                    <span style="color: #40ff72;" v-if="scope.row.status === 1"
                      >有效</span
                    >
                    <span
                      style="color: #f00;"
                      v-else-if="scope.row.status === 0"
                      >过期</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="pagination">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="table.cmxx.currentPage"
                  :page-size="table.cmxx.size"
                  :total="table.cmxx.total"
                  @current-change="currentChangeZlxx"
                ></el-pagination>
              </div> -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <popup
      v-if="dialogVisible"
      @parent="childHanel"
      :companyId="form.belong_company"
    />
    <HardwareList
      :visible="hardwareDialogVisible"
      @visible-change="modalVisibleChange"
      :serviceTypeId="serviceTypeId"
      @success="getHardwareCode"
      :preHardwareCode="preHardwareCode"
    />
  </div>
</template>

<script>
import {
  GetCarDetail,
  GetCarAlarmList,
  GetCarLeaseList,
  editCarInform,
  getCarDoor,
  getconfirm,
  GetdataSelectCarUser,
  queryCarMileage,
  getCarOnOffLineData,
  carUnbind,
  getCarTransfer,
  getDepartment,
} from '@/api/car';
import { getToken } from '@/utils/auth';
import popup from './popup';
import HardwareList from './hardwareList';

import { GetDataSelectXing, queryCarTypeData } from '@/api/system';
import { getAllServiceTypeList } from '@/api/serviceType';
import { selectCompanyData } from '@/api/company';
import { MessageBox } from 'element-ui';
import { unBindData } from '@/api/tbox';
// let usrInfo = JSON.parse(localStorage.getItem('user'));
export default {
  components: { popup, HardwareList },
  data() {
    return {
      disabled: false,
      orderHardwareList: [],
      serviceTypeId: null,
      preHardwareCode: null,
      hardwareDialogVisible: false, // 硬件列表弹窗
      dialogVisible: false,
      token: getToken(),
      id: null,
      frame_num: null,
      edit: false,
      editAdmin: false,
      user_id: '',
      rent_company: '',
      form: {
        photo: '',
        brand: '',
        model: '',
        belong_company: null,
        rent_company: null,
      },
      rules: {
        frame_num: [
          { required: false, message: '请输入车架号', trigger: 'blur' },
          {
            min: 17,
            max: 17,
            message: '车架号固定长为17位！',
            trigger: 'blur',
          },
        ],
        work_num: [
          { required: true, message: '请输入车工号', trigger: 'blur' },
          // { min: 14, max: 14, message: "车工号固定长为14位！", trigger: "blur" }
        ],
        maintenance_time: [
          { required: true, message: '请选择维护时间', trigger: 'blur' },
        ],
        type: [{ required: true, message: '请输入车辆型号', trigger: 'blur' }],
        brand: [{ required: true, message: '请输入车辆品牌', trigger: 'blur' }],
        model: [{ required: true, message: '请输入车型', trigger: 'blur' }],
        belong_company: [
          { required: true, message: '请选择所属公司', trigger: 'blur' },
        ],
        rent_company: [
          { required: false, message: '请选择租聘或个人', trigger: 'blur' },
        ],
        license_num: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ],
        belong_department: [
          { required: true, message: '请输入归属部门', trigger: 'blur' },
        ],
        tbox_num: [{ required: true, message: '请选择tobx', trigger: 'blur' }],
      },
      tabs: {
        avtive: '历史报警数据',
      },
      options: {
        type: [],
        brand: [],
        model: [],
        user: [],
        belongCompDataOptions: [],
        rentCompDataOptions: [],
        carModelOptions: [],
        carTypeOptions: [],
        configOptions: [
          { id: '豪华', name: '豪华' },
          { id: '高配', name: '高配' },
          { id: '低配', name: '低配' },
        ],
      },
      table: {
        lsbjsj: {
          list: [],
          currentPage: 1,
          size: 3,
          total: 2,
        },

        zlxx: {
          list: [
            {
              company: '信息公司',
              name: '张亮',
              card: '330411199403123929',
              info: 'A1',
              datetime_start: '2019-09-10',
              datetime_end: '2019-09-20',
              lcs: '1233',
            },
            {
              company: '信息公司',
              name: '张亮',
              card: '330411199403123929',
              info: 'A1',
              datetime_start: '2019-09-22',
              datetime_end: '2019-09-24',
              lcs: '1222',
            },
          ],
          currentPage: 1,
          size: 3,
          total: 2,
        },
        cmxx: {
          list: [],
          currentPage: 1,
          size: 50,
          total: 2,
        },
      },
      belongCompData: [],
      rentCompData: [],
      receiveCompData: [],
      brandModelData: [],
      modelTypeData: [],
      onOffLineRecord: [],
      roleId: '',
      recordParam: { sn: '', pageSize: 10, pageNo: 1 },
      recordCount: 0,
      tboxData: [],
      tboxSelectVisible: false,
      editForm: {
        tbox_num: '',
      },
      transferData: [],
      departList: [],
      serviceList: [], //服务类型
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.frame_num = this.$route.query.frame_num;
    this.rent_company = this.$route.query.rent_company;
    this.recordParam.sn = this.$route.query.tbox_num;
    this.getData();
    this.getCarAlarmData();
    this.getCarLeaseData();
    this.getCarDoor();
    // this.GetSelect();
    this.initCarOnOffLineData();
    // this.getTboxList()
    this.getCarTransfer();
    // this.getDepartment()
  },
  methods: {
    //清除
    clearHardware(index) {
      const serviceList = [...this.serviceList];
      serviceList[index].code = '';
      this.serviceList = serviceList;
    },

    // 显示弹窗
    showHardwareDialog(id, code) {
      this.preHardwareCode = code || '';
      this.hardwareDialogVisible = true;
      this.serviceTypeId = id;
    },
    modalVisibleChange(val) {
      this.hardwareDialogVisible = val;
    },

    getHardwareCode(code) {
      //获取
      const newServiceType = [...this.serviceList];
      const index = newServiceType
        .map((item) => item.id)
        .indexOf(this.serviceTypeId);
      if (index !== -1) {
        newServiceType[index].code = code;
      }
      this.serviceList = newServiceType;
    },

    //获取部门
    getDepartment(id) {
      if (!id) {
        return;
      }
      getDepartment({ companyId: id }).then((da) => {
        this.departList = da.data;
      });
    },
    //车辆变更记录查询
    getCarTransfer() {
      let params = {
        id: this.id,
        pageNum: 1,
        pageSize: 999,
      };
      getCarTransfer(params).then((da) => {
        this.transferData = da.data.content;
      });
    },
    openEditBtn() {
      this.editForm.tbox_num = JSON.parse(JSON.stringify(this.form.tbox_num));
      this.tboxSelectVisible = true;
    },
    closeEditBtn() {
      this.form.tbox_num = this.editForm.tbox_num;
      this.tboxSelectVisible = false;
    },
    editTbox() {
      MessageBox.confirm('确认更换?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.submitForm('form');
        })
        .catch(() => {
          // this.$message('已取消注销')
        });
    },
    getTboxList() {
      unBindData({ companyId: this.form.belong_company }).then((res) => {
        this.tboxData = res.data.content;
      });
    },
    //解绑
    untie() {
      MessageBox.confirm('确认解绑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // console.log(this.$route.query.id)
          carUnbind({ id: this.$route.query.id }).then((res) => {
            if (res.code == 0) {
              this.$message.success('解绑成功!');
              // this.refresh()
              this.getData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // this.$message('已取消注销')
        });
      // carUnbind({id:this.form})
    },
    childHanel(val) {
      this.form.tbox_num = val.tbox_num;
    },
    GetSelect(id) {
      GetdataSelectCarUser().then((res) => {
        this.options.user = res.data.content;
      });
      if (!id) {
        return;
      }
      GetDataSelectXing({ companyId: id }).then((res) => {
        this.options.brand = res.data.content;
      });
      //  GetdataSelectType().then(res=>{
      //   this.options.type =  res.data.content
      // })
      //  GetdataSelectCar().then(res=>{
      //   this.options.model =  res.data.content
      // })
      queryCarTypeData({ companyId: id }).then((res) => {
        this.brandModelData = res.data.brandModel;
        this.modelTypeData = res.data.modelType;
        this.initModeTypeSelect();
      });
    },

    async getServiceTypeList() {
      const hardwareList = this.form.hardware;

      hardwareList.forEach((element) => {
        if (element.orderExpireTime) {
          const dd = new Date(element.orderExpireTime).getTime();
          const nowTime = new Date().getTime();
          if (dd - nowTime > 0) {
            element.status = 1;
          } else {
            element.status = 0;
          }
        }
      });

      this.orderHardwareList = hardwareList; //服务订购tab
      const { data } = await getAllServiceTypeList();

      const serviceTypeList = data; // 服务类型
      serviceTypeList.forEach((element) => {
        const obj =
          hardwareList.find((item) => item.serviceTypeId === element.id) || {};
        element.code = obj.code || '';
      });
      this.serviceList = serviceTypeList;
    },

    getData() {
      const params = { id: this.$route.query.id };
      GetCarDetail(params).then((res) => {
        if (res.data.rent_company != null && res.data.rent_company != '') {
          res.data.rent_company = Number(res.data.rent_company);
        }
        if (res.data.belong_company != null && res.data.belong_company != '') {
          res.data.belong_company = Number(res.data.belong_company);
        }
        // if (res.data.configuration != null && res.data.configuration != "") {
        //   res.data.configuration = Number(res.data.configuration);
        // }
        // this.form = res.data;
        // // console.log(this.form)
        // this.getDepartment(this.form.belong_company)
        // this.GetSelect(this.form.belong_company)
        this.initCompanyData(res.data);
        this.getServiceTypeList(); //配置已选择的硬件
        if (this.form.tbox_num != null) {
          var snt = [this.form.tbox_num];
          let sn = JSON.stringify(snt);
          queryCarMileage({ sn: sn }).then((res) => {
            if (res.code != 1) {
              let list = this.table.zlxx.list;
              if (list.length > 0 && this.table.zlxx.list[0].end_time == '') {
                this.table.zlxx.list[0].over_mile = res.data[0].totalMileage;
              }
            }
          });
        }
      });
    },
    getCarAlarmData() {
      const params = {
        id: this.frame_num,
        start: this.table.lsbjsj.currentPage,
        size: this.table.lsbjsj.size,
      };
      GetCarAlarmList(params).then((res) => {
        const data = res.data;
        this.table.lsbjsj.list = data.content;
        this.table.lsbjsj.total = data.total;
      });
    },
    getCarLeaseData() {
      const params = {
        id: this.frame_num,
        start: this.table.zlxx.currentPage,
        size: this.table.zlxx.size,
      };
      GetCarLeaseList(params).then((res) => {
        const data = res.data;
        this.table.zlxx.list = data.content;
        this.table.zlxx.total = data.total;
      });
    },
    // 获取车门
    getCarDoor() {
      const params = {
        id: this.frame_num,
        start: this.table.cmxx.currentPage,
        size: this.table.cmxx.size,
      };
      getCarDoor(params).then((res) => {
        const data = res.data;
        this.table.cmxx.list = data.content;
        this.table.cmxx.total = data.total;
      });
    },
    //车辆品牌选中事件
    brandChange() {
      let brand = this.form.brand;
      if (brand != null && brand != '') {
        this.options.carModelOptions = [];
        this.form.model = null;
        this.options.carTypeOptions = [];
        this.form.type = null;
        this.brandModelData.forEach((el) => {
          if (el.brand == brand) {
            el.id = el.id != null && el.id != '' ? Number(el.id) : null;
            this.options.carModelOptions.push(el);
          }
        });
      }
    },
    //车型选中事件
    modelChange() {
      let model = this.form.model;
      if (model != null && model != '') {
        this.options.carTypeOptions = [];
        this.form.type = null;
        this.modelTypeData.forEach((el) => {
          if (el.car_model == model) {
            this.options.carTypeOptions.push(el);
          }
        });
      }
    },
    initModeTypeSelect() {
      //初始化车型
      let brand = this.form.brand;
      if (brand != null && brand != '') {
        this.brandModelData.forEach((el) => {
          if (el.brand == brand) {
            el.id = el.id != null && el.id != '' ? Number(el.id) : null;
            this.options.carModelOptions.push(el);
          }
        });
      }
      //初始化型号
      let model = this.form.model;
      if (model != null && model != '') {
        this.options.carTypeOptions = [];
        this.modelTypeData.forEach((el) => {
          if (el.car_model == model) {
            this.options.carTypeOptions.push(el);
          }
        });
      }
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let hardwareList = [];
          this.serviceList.forEach((item) => {
            if (item.code !== '') {
              hardwareList.push({
                serviceTypeId: item.id,
                code: item.code,
              });
            }
          });
          this.form.hardwareList = hardwareList;
          this.form.id = this.$route.query.id;
          // this.form.user_id = this.user_id
          // console.log(this.form)
          editCarInform(this.form)
            .then((res) => {
              if (res.code !== 0) {
                this.$message.error(res.message);
                return;
              }
              this.disabled = false;
              this.edit = false;
              this.tboxSelectVisible = false;
              this.$message.success('保存成功!');
            })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          return false;
        }
      });
    },
    // 编辑
    editClick() {
      this.defalutValue = this.form.belong_company;
      this.edit = true;
      if (this.isNotEmpty(this.rent_company)) {
        this.editAdmin = true;
      } else {
        this.editAdmin = false;
      }
    },
    // 保存
    saveClick() {},
    // 取消
    cancelClick() {
      this.edit = false;
      this.getData();
      this.GetSelect(this.form.belong_company);
    },
    // handleClick(tab, event) {},
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        this.form.photo = res.data.src;
      }
    },
    // 历史报警数据查看
    readClickLsbjsj(id, status) {
      getconfirm({
        id,
        status,
      }).then(() => {
        this.getCarAlarmData();
      });
    },
    initCarOnOffLineData() {
      getCarOnOffLineData(this.recordParam).then((res) => {
        if (res.code == 0) {
          this.onOffLineRecord = res.data.list;
          this.recordCount = res.data.total;
        }
      });
    },
    // 租赁信息查看
    readClickZlxx() {},
    // 历史报警数据翻页
    currentChangeLsbjsj() {
      this.getCarAlarmData();
    },
    // 租赁信息翻页
    currentChangeZlxx() {
      this.getCarLeaseData();
    },
    //车辆型号选择后展示车辆图片信息
    typeChange() {
      let chooseType = this.form.type;
      this.options.type.forEach((el) => {
        if (el.id == chooseType) {
          this.form.type_img = el.type_img;
        }
      });
    },
    //所属公司选中事件
    selectChange() {
      this.form.belong_department = '';
      this.form.brand = '';
      this.form.type = '';
      this.form.model = '';
      this.clearRentDataOptions();
      this.initRentCompanyData(this.form.belong_company);
      this.getDepartment(this.form.belong_company);
      this.GetSelect(this.form.belong_company);
    },
    //获取所属公司数据
    initCompanyData(returnData) {
      selectCompanyData().then((res) => {
        if (res.code == 0) {
          this.receiveCompData = res.data;
          this.initBelongCompanyData();
        }
      });
      this.form = returnData;
      this.getTboxList();
      this.getDepartment(this.form.belong_company);
      this.GetSelect(this.form.belong_company);
    },
    //获取租赁公司数据
    initRentCompanyData(compId) {
      this.receiveCompData.forEach((el) => {
        if (el.parent_comp_id == compId) {
          this.options.rentCompDataOptions.push(el);
        }
      });
    },
    //获取所属公司数据
    initBelongCompanyData() {
      this.receiveCompData.forEach((el) => {
        this.options.belongCompDataOptions.push(el);
      });
      if (this.$store.state.home.RoleId == this.user_role_rent) {
        const belongCompany = JSON.parse(localStorage.user).belongCompany;
        this.form.belong_company = Number(belongCompany);
      }
      this.initRentCompanyData(this.form.belong_company);
    },
    //清理租赁公司
    clearRentDataOptions() {
      this.form.rent_company = null;
      this.options.rentCompDataOptions = [];
    },
    //非空判断
    isNotEmpty(str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.car-detail-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .tools {
      padding-bottom: 20px;
      .title {
        float: left;
        font-size: 18px;
        line-height: 40px;
        font-weight: bold;
        color: #1f7eb8;
      }
      .btn-edit {
        float: right;
        margin-left: 14px;
      }
    }
    .box {
      display: flex;
      padding-top: 30px;
      width: 100%;
      .avatar {
        .img {
          width: 450px;
          img {
            // width: 100%;
            width: 450px;
            height: 275px;
          }
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
        .value {
          display: inline-block;
          width: 100%;
          padding: 0 16px;
          line-height: 41px;
        }
      }
    }
    /deep/.el-date-editor.el-input {
      width: 100%;
    }
  }
  .pagination {
    padding-top: 20px;
    text-align: right;
  }
  .reads {
    margin-left: 12px;
    color: #5eaee2;
    text-decoration: underline;
    font-weight: 200;
    cursor: pointer;
  }
}
</style>
<style>
.avatar-uploader .el-upload {
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  font-size: 28px;
  color: #8c939d;
  width: 450px;
  height: 275px;
  line-height: 275px;
  text-align: center;
}
.avatar {
  width: 450px;
  height: 275px;
  display: block;
}
.el-select .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border: 0;
  cursor: auto;
  color: #333;
  border-color: #c0c4cc;
}
.el-select .el-input.is-disabled .el-input__suffix {
  display: none;
}
</style>
